import { AiFillAppstore } from "react-icons/ai";
import { FaGlobe} from "react-icons/fa";
import {  SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Business Strategy",
    des: "I specialize in developing and implementing effective strategies to drive business growth. I have expertise in strategic planning, competitive analysis, and business model innovation",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "I am skilled in troubleshooting, debugging, and optimizing app performance to deliver exceptional user experiences. My portfolio includes a range of successful apps",
  },
  {
    id: 3,
    icon: <SiAntdesign />,
    title: "UX/UI  Design",
    des: "I have a passion for crafting seamless and visually engaging digital experiences. I possess a deep understanding of user-centered design principles, information architecture, and usability testing",
  },
  {
    id: 4,
    icon: <FaGlobe />,
    title: "Hosting Websites",
    des: "I have a comprehensive understanding of website hosting and can guide you through the process of getting your website live.",
  },
];
